import constate from "constate";
import { useForm } from "react-hook-form";
import { useLens } from "@hookform/lenses";
import type { CompositionsForm, CompositionForm } from "@design-lab/shared/types";

function useCompositionFormCreator() {
  const form = useForm<CompositionsForm>({
    defaultValues: {
      currentCompositionId: "",
      addedCompositions: []
    },
    mode: "onChange"
  });

  const lens = useLens(form);

  const validateComposition = (composition: CompositionForm) => {
    if (!composition) {
      return true;
    }
    const hasAnyVariant = Object.values(composition.variants || {}).some(quantity => quantity > 0);
    return hasAnyVariant || "Pick a size and quantity before adding to cart";
  };

  const registerValidationForAllCompositions = () => {
    const compositions = form.getValues("addedCompositions");
    compositions.forEach((_, index) => {
      form.register(`addedCompositions.${index}`, {
        validate: { hasVariants: validateComposition }
      });
    });
  };

  return {
    form,
    lens,
    validateComposition,
    registerValidationForAllCompositions
  };
}

export const [CompositionFormProvider, useCompositionForm] = constate(useCompositionFormCreator);
